// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4w-2";
export var blackBorderOnHover = "_4w-7";
export var cell = "_4w-6";
export var cellContainer = "_4w-3";
export var checked = "_4w-8";
export var disabled = "_4w-5";
export var featuredIconCellContainer = "_4w-9";
export var featuredIconTextContainer = "_4w-b";
export var featuredIconWrapper = "_4w-a";
export var noBorder = "_4w-c";
export var orangeSelectedRow = "_bw-3";
export var overflowableText = "_4w-0";
export var overflowableTextContainer = "_4w-1";
export var row = "_4u-0";
export var rowCheckboxCell = "_4w-4";
export var selectableTable = "_bw-2";